import React, { useEffect } from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image';

import { THEME } from '@constants/index';
import I18n from '@utils/i18n';

import registerStyles from './index.module.css';

export const passwordValidator = (password) => {
  if (!password) {
    return Promise.reject(new Error(''));
  }

  if (!(password.length > 5 && password.length < 21 && password.match(/^(?=.*[a-zA-Z])(?=.*[0-9])/))) {
    return Promise.reject(new Error(''));
  }

  return Promise.resolve();
}

const getIsSixToTwenty = (pwd) => {
  console.log()
  if (pwd?.length > 5 && pwd?.length < 21) {
    return true;
  }
  return false;
}

const getIsNumAndLetter = (pwd) => {
  const reg1 = /^(?=.*[a-zA-Z])(?=.*[0-9])/;
  if (pwd.match(reg1) == null) {
    return false;
  }
  return true;
}

export default function PWDValidateModal (props) {
  const { password, onChange = () => {}, theme } = props;
  const isSixToTwenty = getIsSixToTwenty(password);
  const isNumAndLetter = getIsNumAndLetter(password);
  useEffect(() => {
    onChange(isSixToTwenty, isNumAndLetter)
  }, [isSixToTwenty, isNumAndLetter])
  function renderIcon (success) {
    return (
    <span className={registerStyles.pwdModalIcon}>
      <Image
        src={require(success ? '../../images/icon/successSmail.webp' : '../../images/icon/errorSmail.webp')}
        layout="fixed"
        width={12}
        height={12}
        alt='kikitrade'
      />
    </span>
    )
  }

  return (
    <div className={cn(registerStyles.pwdModal, {
      [registerStyles.dark]: theme === THEME.DARK
    })}>
        <div className={registerStyles.pwdModalTitle}>{I18n.t('register_password_condition')}</div>
          <div className={registerStyles.pwdModalContent}>
            <p className={registerStyles.pwdModalStep}>
              {renderIcon(isSixToTwenty)}
              <span>{I18n.t('register_password_condition_one')}</span>
            </p>
            <p className={registerStyles.pwdModalStep}>
              {renderIcon(isNumAndLetter)}
              <span>{I18n.t('register_password_condition_two')}</span>
            </p>
        </div>
    </div>
  )
}
